import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/auth';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { EnhancedThemeProvider } from './theme/enhanced-theme-provider';
import { Spin } from 'antd';
import 'antd/dist/reset.css';
import './theme/base.css';
import './App.css';

// Lazy load pages
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const CallbackPage = React.lazy(() => import('./pages/CallbackPage'));
const SilentCallbackPage = React.lazy(() => import('./pages/SilentCallbackPage'));
const UnauthorizedPage = React.lazy(() => import('./pages/UnauthorizedPage'));

function App() {
  const { checkAuth, isLoading, isAuthenticated } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (isLoading) {
    return (
      <div className="app-loading">
        <Spin size="large" tip="Initializing..." style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} />
      </div>
    );
  }

  return (
    <EnhancedThemeProvider>
      <Router>
        <div className="app">
          <React.Suspense fallback={<Spin size="large" tip="Loading page..." style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} />}>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/callback" element={<CallbackPage />} />
              <Route path="/silent-callback" element={<SilentCallbackPage />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              
              {/* Protected routes */}
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              />

              {/* Default redirect */}
              <Route
                path="/"
                element={
                  isAuthenticated ? 
                    <Navigate to="/app" replace /> :
                    <Navigate to="/login" replace />
                }
              />

              {/* Catch all - redirect to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </React.Suspense>
        </div>
      </Router>
    </EnhancedThemeProvider>
  );
}

export default App;